import {
  handleChildAdd,
  updateParentDuration,
  updateTaskMassive,
  updateAsyncActivityHelperHack,
  updateRenderHelperHack,
  handleDelete,
  updateIsParent,
  assignCorrelativeNumbers,
  updateAsyncTaskGanttV2,
  findDeepGetTaskRecursive
} from '../../../GanttVisualization.helper';
import { trackingEvent } from '../../../../../analytics';
import { AMPLITUDE_SERVICE } from '../../../../../analytics/constants';
import { getBasicAmplitudEventProperties } from '../../../../../analytics/utils';
import {
  convertPPActivity2PluginTask,
  convertPPTask2PluginTask
} from '../../../../../views/lookahead/planification/index.helper';
import { ganttAPI } from '../../../../../utils/customGanttPlugin';
import { store } from '../../../../../redux/store';
import deleteIcon from '../../../../../assets/img/newlookahead/name/delete.png';
import i18n from '../../../../../i18n';

async function openRoadblockModal(taskId) {
  if (!taskId) return;
  const gantt = window.ganttVisualization;
  gantt.addConstraint(taskId);
  const thisTask = gantt.getTask(taskId);
  trackingEvent(
    'roadblock_creation_button_selection',
    {
      ...getBasicAmplitudEventProperties(),
      task_id: thisTask.id,
      task_name: thisTask.name,
      event_source: 'planning'
    },
    AMPLITUDE_SERVICE
  );
}

async function addTaskToATask(taskId, activityId) {
  if (!taskId || taskId === null) return;
  const gantt = window.ganttVisualization;
  const thisTask = gantt.getTask(taskId);
  thisTask.is_parent = true;

  const thisActivityReferenceLvl = window.activities.find(
    (act) => act.unique_id == thisTask.activityReference?.id
  );
  const state = store.getState();
  const projectState = state.projectState;
  let taskFromLookahead = findDeepGetTaskRecursive(
    window.activities,
    'id',
    taskId
  );

  const toAdd = await handleChildAdd(
    taskFromLookahead,
    thisActivityReferenceLvl,
    projectState,
    updateAsyncActivityHelperHack,
    () => {},
    gantt
  );

  trackingEvent(
    'lookahead_task_creation',
    {
      ...getBasicAmplitudEventProperties(),
      task_id: toAdd.id,
      parent_activity_name: thisActivityReferenceLvl?.name,
      parent_activity_id: thisActivityReferenceLvl?.id,
      event_source: 'subtask_add'
    },
    AMPLITUDE_SERVICE
  );

  const adaptedTask = convertPPTask2PluginTask(toAdd, null, thisTask);
  delete adaptedTask.parent;
  adaptedTask.activityReference = convertPPActivity2PluginTask(
    thisActivityReferenceLvl
  );
  gantt.createTask(adaptedTask, taskId);

  /** update parent */
  const arrMass = [];
  if (adaptedTask.parent) {
    updateParentDuration(
      adaptedTask.parent,
      adaptedTask.activityReference,
      arrMass,
      gantt,
      ganttAPI,
      projectState
    );
  }
  /** save data */
  updateTaskMassive(arrMass);

  gantt.refreshVisualizations && gantt.refreshVisualizations(adaptedTask);
}

async function deleteEvent(taskId) {
  if (!taskId || taskId === null) return;
  const gantt = window.ganttVisualization;
  const thisTask = gantt.getTask(taskId);
  const thisActivityReferenceLvl = window.activities.find(
    (act) => act.unique_id == thisTask.activityReference?.id
  );
  //avoidOptimizationTimelineBlinking();
  // addRef.tooltip.setState({ visible: false })
  const state = store.getState();
  const projectState = state.projectState;
  let taskFromLookahead = findDeepGetTaskRecursive(
    window.activities,
    'id',
    taskId
  );

  let parentTask = null;
  if (taskFromLookahead) {
    if (taskFromLookahead.parent_id) {
      parentTask = findDeepGetTaskRecursive(
        window.activities,
        'id',
        taskFromLookahead.parent_id
      );
    }
  }

  await handleDelete(
    taskFromLookahead,
    thisActivityReferenceLvl,
    parentTask,
    updateAsyncTask,
    updateAsyncActivityHelperHack,
    projectState,
    i18n,
    updateRenderHelperHack,
    gantt
  );

  trackingEvent(
    'lookahead_task_deletion',
    {
      ...getBasicAmplitudEventProperties(),
      task_id: thisTask?.id,
      task_name: thisTask?.name,
      parent_activity_name: thisActivityReferenceLvl?.name,
      parent_activity_id: thisActivityReferenceLvl?.id
    },
    AMPLITUDE_SERVICE
  );

  /** if parentTask no has children, update this parentTask */
  if (parentTask?.children && parentTask.children?.length === 0)
    updateIsParent(thisTask, parentTask, gantt);

  if (thisActivityReferenceLvl.tasks.length > 0) {
    assignCorrelativeNumbers(thisActivityReferenceLvl.tasks);
  }

  /** update parent */
  const arrMass = [];
  if (taskFromLookahead?.isTask && parentTask?.children.length) {
    updateParentDuration(
      taskFromLookahead.parent_id,
      thisActivityReferenceLvl,
      arrMass,
      gantt,
      ganttAPI,
      projectState
    );
  }
  /** save data */
  if (arrMass.length) {
    updateTaskMassive(arrMass);
  }
}

async function openDeleteTaskTooltip(taskId, element) {
  const container = element.closest('.PopConfirmHTML');
  const { top, left } = getOffsetPosition(element);
  const existing = document.querySelector('.PopConfirmHTMLContent');
  if (existing) existing.remove();

  const popup = document.createElement('span');
  popup.className = 'PopConfirmHTMLContent';
  popup.style.top = `${top - 10}px`;
  popup.style.left = `${left}px`;

  popup.innerHTML = `
    <div class="PopConfirmHTMLContent__title" style="display: flex; align-items: center;">
      <img src="${deleteIcon}" style="width: 18px; height: 18px; color: red" />
      <div class="ant-popover-message-title" style="padding: 0 0 0 8px">
        ${i18n.t('lookahead_resources.confir_delete')}
      </div>
    </div>
    <div class="PopConfirmHTMLContent__buttons" style="margin-top: 8px; display: flex; gap: 8px;">
      <button type="button" class="ant-btn ant-btn-sm btn-cancel">${i18n.t(
        'cancel'
      )}</button>
      <button type="button" class="ant-btn ant-btn-primary ant-btn-sm btn-confirm">${i18n.t(
        'ok_text'
      )}</button>
    </div>
  `;

  container.appendChild(popup);

  const closePopup = () => {
    popup.remove();
    document.removeEventListener('click', handleClickOutside);
  };

  const handleClickOutside = (e) => {
    if (!popup.contains(e.target)) {
      closePopup();
    }
  };

  document.addEventListener('click', handleClickOutside);

  popup.querySelector('.btn-cancel').addEventListener('click', (e) => {
    e.stopPropagation();
    closePopup();
  });

  popup.querySelector('.btn-confirm').addEventListener('click', async (e) => {
    e.stopPropagation();
    closePopup();
    deleteEvent(taskId);
  });
}

async function addTask(taskId) {
  if (!taskId || taskId === null) return;
  const gantt = window.ganttVisualization;
  const thisTask = gantt.getTask(taskId);
  thisTask.is_parent = true;
  try {
    let activityData = null;
    let taskFromLookahead = null;

    if (thisTask.activityReference?.id) {
      taskFromLookahead = findDeepGetTaskRecursive(
        window.activities,
        'id',
        taskId
      );
      activityData = window.activities.find(
        (act) => act.unique_id == thisTask.activityReference?.id
      );
    }

    if (thisTask?.isTask) {
      /** get reference task (taskFromLookahead) from activities */
      taskFromLookahead = findDeepGetTaskRecursive(
        window.activities,
        'id',
        taskId
      );
    }
    // addRef && addRef.tooltip.setState({ visible: false })
    const toAdd = await handleChildAdd(
      taskFromLookahead,
      activityData,
      () => {},
      updateAsyncActivityHelperHack,
      updateRenderHelperHack,
      gantt
    );

    trackingEvent(
      'lookahead_task_creation',
      {
        ...getBasicAmplitudEventProperties(),
        task_id: toAdd.id,
        parent_activity_name: activityData?.name,
        parent_activity_id: activityData?.id,
        event_source: 'subtask_add'
      },
      AMPLITUDE_SERVICE
    );

    const adaptedTask = convertPPTask2PluginTask(toAdd, null, thisTask);
    delete adaptedTask.parent;
    adaptedTask.activityReference = convertPPActivity2PluginTask(activityData);
    gantt.createTask(adaptedTask, taskId);

    /** update parent */
    const arrMass = [];
    if (adaptedTask.parent) {
      updateParentDuration(
        adaptedTask.parent,
        adaptedTask.activityReference,
        arrMass,
        gantt,
        ganttAPI,
        () => {}
      );
    }
    /** save data */
    updateTaskMassive(arrMass);

    gantt.refreshVisualizations && gantt.refreshVisualizations(adaptedTask);
  } catch (error) {
    thisTask.is_parent = false;
  }
}
function getOffsetPosition(el) {
  const rect = el.getBoundingClientRect();
  return {
    top: rect.top,
    left: rect.left
  };
}

const updateAsyncTask = async (taskLocal) => {
  const gantt = window.ganttVisualization;
  await updateAsyncTaskGanttV2(
    taskLocal,
    'actions',
    taskLocal.name,
    gantt,
    true,
    false,
    false,
    true
  );
};
export default {
  addTask,
  addTaskToATask,
  deleteEvent,
  openDeleteTaskTooltip,
  openRoadblockModal
};
